import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PermissionsResponseSchema } from "../response/PermissionsResponseSchema";

interface useGetPermissionsProps {
    name: string;
    page: number;
    limit: number;
    search: string;
}

export const useGetPermissions = ({ name, page, limit, search }: useGetPermissionsProps) => {
    return useQuery({
        queryKey: [name, page, limit, search],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v3/permission', {
                    params: {
                        page: page,
                        limit: limit,
                        search: search,
                    }
                });

                const validationResult = PermissionsResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid permissions data format");
                }
                return validationResult.data;

            } catch (error) {
                console.error('Failed to fetch permissions', error);
                throw error;
            }
        },
        retry: 3,
        refetchOnWindowFocus: false,
    });
};